import React, { useCallback, useMemo } from 'react';
import { Setting, SettingInfo, SettingsSectionSubHeading } from 'components/Setting/style';
import _debounce from 'lodash/debounce';
import { ContactAdminTooltip } from 'components/Tooltip';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { Toggle } from '@econsult/econsult-ui/dist/components/Toggle';
import { ErrorToast } from 'components/Toast';
import { STRINGS } from 'config';
import { saveCustomClosureMessage } from 'store/action/demandManagement';
import { CustomMessageToggleSettingDetail, CustomMessageToggleWrapper } from 'components/CustomLandingPageMessage/style';

const { PENDING, SUCCEEDED, FAILED } = STRINGS.REQUEST_STATUS;

export const ShowDefaultCustomClosureMessageToggle = props => {
  const {
    selectedPracticeHasAdminRights,
    message,
    showDefaultMessage,
    maxMessageLength,
    selectedPractice,
    setShowDefaultMessage,
    setSaveRequestStatus,
    isGetRequestPending,
    isSaveRequestPending,
    isToggleDisabled,
  } = props;

  const onToggle = useCallback(() => {
    if (!selectedPractice || isToggleDisabled || isGetRequestPending || isSaveRequestPending) {
      return null;
    }

    setShowDefaultMessage(value => !value);

    if (message.length > maxMessageLength) {
      return toast(<ErrorToast message="Message is too long." />);
    }

    if (!message.length) {
      return toast(<ErrorToast message="No custom message configured" />);
    }

    setSaveRequestStatus(PENDING);

    return saveCustomClosureMessage({
      practiceId: selectedPractice.id,
      showDefaultMessage: !showDefaultMessage,
      message: message.trim(),
    })
      .then(isSuccess => {
        if (!isSuccess) {
          return setSaveRequestStatus(FAILED);
        }

        return setSaveRequestStatus(SUCCEEDED);
      });
  }, [
    isGetRequestPending,
    isSaveRequestPending,
    isToggleDisabled,
    maxMessageLength,
    message,
    selectedPractice,
    setSaveRequestStatus,
    setShowDefaultMessage,
    showDefaultMessage,
  ]);

  const debouncedToggle = useMemo(() => _debounce(onToggle, 2_000, { leading: true }), [onToggle]);

  return (
    <Setting>
      <SettingInfo>
        <SettingsSectionSubHeading>
          Default message visibility
        </SettingsSectionSubHeading>

      </SettingInfo>

      <CustomMessageToggleSettingDetail>
        <CustomMessageToggleWrapper>
          <Toggle
            id="showDefaultCustomClosureMessage"
            name="showDefaultCustomClosureMessage"
            isChecked={showDefaultMessage}
            onClick={debouncedToggle}
            label="Show default message during closure"
            disabled={isToggleDisabled}
          />

          {isToggleDisabled && (
            <ContactAdminTooltip show={!selectedPracticeHasAdminRights} automationLabel="SaveDefaultClosureMessageDisabledTooltip" />
          )}
        </CustomMessageToggleWrapper>
      </CustomMessageToggleSettingDetail>
    </Setting>
  );
};
